import * as React from "react"
import { Appearance } from "react-native"
import { observer } from "mobx-react-lite"
import { nativeBaseTheme } from "../../theme"
import { Icon } from "native-base"
import { JalaIcon } from "../jala-icon/jala-icon"
import { IIconProps } from "native-base/lib/typescript/components/primitives/Icon/types"

const weatherIcons = {
  400: 'weather-rain-storm',
  450: 'weather-rain-heavy',
  500: 'weather-rain-normal',
  600: 'weather-cloudy',
  700: 'weather-sunny-cloudy',
  800: 'weather-sunny',
  900: 'weather-sunny-heavy'
};

export interface JalaWeatherIconProps extends IIconProps {
  weatherId: keyof typeof weatherIcons,
  colorScheme?: "light"|"dark",
}

/**
 * Describe your component here
 */
export const JalaWeatherIcon = observer(function JalaWeatherIcon(props: JalaWeatherIconProps) {
  const { colorScheme = "light" || Appearance.getColorScheme(), weatherId, ...rest } = props

  const iconBaseStyle = nativeBaseTheme.components.Icon.baseStyle({ colorMode: colorScheme });

  return <Icon {...iconBaseStyle} as={JalaIcon} name={weatherIcons[weatherId]} {...rest} />
})
